import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async create(guidelineVersionId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'admin/guideline_version',
      parentId: guidelineVersionId,
      modelName: 'guideline_article',
      data: _data,
    });
    return res;
  },
  async batch(guidelineVerId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'admin/guideline_version',
      parentId: guidelineVerId,
      modelName: 'batch/guideline_article',
      data: _data,
    });
    return res;
  }
}